import HomeDetails from "./HomeDetails";

export default HomeDetails;